import Api from './api.service';

export default {
  get: () => Api.get('states'),
  getId: (id) => Api.get(`states/${id}`),
  search: (term = '') => Api.get(`states?filter[name]=${term}`),
};
